import { Button } from 'components/atoms';
import React from 'react';
import { useTranslation } from 'utils/hooks';


import css from './PurchasableDocument.module.scss';

interface PurchasableDocumentProps
{
  text: string;
  href: string;
}

const PurchasableDocument: React.FC<PurchasableDocumentProps> = (props) =>
{
  const { t } = useTranslation('profiles');
  const { text, href } = props;

  return (
    <li>
      <a
        href={href}
        target="_blank"
        className={css.document}
        rel="noreferrer"
      >
        <span>{text}</span>
        <Button variant="secondary">
          {t('profiles:actions.buyDocument')}
        </Button>
      </a>
    </li>
  );
};

export default PurchasableDocument;
